import { Box, Button, Stack, Typography } from "@mui/material"
import { rise } from "../motion"

/**
 * What an empty list says.
 *
 * Always a reason and, where there is one, the action that fills it. "No results"
 * on its own leaves the reader unsure whether the app is broken, their filter is
 * wrong, or there genuinely is nothing.
 */
export default function EmptyState({ icon: Icon, title, description, actionLabel, onAction }) {
  return (
    <Box sx={{ py: 8, px: 3, textAlign: "center", ...rise() }}>
      <Stack spacing={1.5} alignItems="center">
        {Icon ? <Icon sx={{ fontSize: 40, color: "text.secondary", opacity: 0.6 }} /> : null}
        <Typography variant="h3">{title}</Typography>
        {description ? (
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
            {description}
          </Typography>
        ) : null}
        {actionLabel && onAction ? (
          <Button variant="contained" onClick={onAction} sx={{ mt: 1 }}>
            {actionLabel}
          </Button>
        ) : null}
      </Stack>
    </Box>
  )
}
